import { __export } from "./armor-system-JQVN7XCJ.js";

// src/tokens/color.ts
var color_exports = {};
__export(color_exports, {
  colorBlue05: function colorBlue05() {
    return _colorBlue;
  },
  colorBlue10: function colorBlue10() {
    return _colorBlue2;
  },
  colorBlue20: function colorBlue20() {
    return _colorBlue3;
  },
  colorBlue30: function colorBlue30() {
    return _colorBlue4;
  },
  colorBlue40: function colorBlue40() {
    return _colorBlue5;
  },
  colorBlue50: function colorBlue50() {
    return _colorBlue6;
  },
  colorBlue60: function colorBlue60() {
    return _colorBlue7;
  },
  colorBlue70: function colorBlue70() {
    return _colorBlue8;
  },
  colorBlue80: function colorBlue80() {
    return _colorBlue9;
  },
  colorBlue90: function colorBlue90() {
    return _colorBlue10;
  },
  colorGreen05: function colorGreen05() {
    return _colorGreen;
  },
  colorGreen10: function colorGreen10() {
    return _colorGreen2;
  },
  colorGreen20: function colorGreen20() {
    return _colorGreen3;
  },
  colorGreen30: function colorGreen30() {
    return _colorGreen4;
  },
  colorGreen40: function colorGreen40() {
    return _colorGreen5;
  },
  colorGreen50: function colorGreen50() {
    return _colorGreen6;
  },
  colorGreen60: function colorGreen60() {
    return _colorGreen7;
  },
  colorGreen70: function colorGreen70() {
    return _colorGreen8;
  },
  colorGreen80: function colorGreen80() {
    return _colorGreen9;
  },
  colorGreen90: function colorGreen90() {
    return _colorGreen10;
  },
  colorGrey00: function colorGrey00() {
    return _colorGrey;
  },
  colorGrey01: function colorGrey01() {
    return _colorGrey2;
  },
  colorGrey05: function colorGrey05() {
    return _colorGrey3;
  },
  colorGrey10: function colorGrey10() {
    return _colorGrey4;
  },
  colorGrey20: function colorGrey20() {
    return _colorGrey5;
  },
  colorGrey30: function colorGrey30() {
    return _colorGrey6;
  },
  colorGrey40: function colorGrey40() {
    return _colorGrey7;
  },
  colorGrey50: function colorGrey50() {
    return _colorGrey8;
  },
  colorGrey60: function colorGrey60() {
    return _colorGrey9;
  },
  colorGrey60WithOpacity: function colorGrey60WithOpacity() {
    return _colorGrey60WithOpacity;
  },
  colorGrey70: function colorGrey70() {
    return _colorGrey10;
  },
  colorGrey80: function colorGrey80() {
    return _colorGrey11;
  },
  colorGrey90: function colorGrey90() {
    return _colorGrey12;
  },
  colorPurple20: function colorPurple20() {
    return _colorPurple;
  },
  colorPurple50: function colorPurple50() {
    return _colorPurple2;
  },
  colorRed05: function colorRed05() {
    return _colorRed;
  },
  colorRed10: function colorRed10() {
    return _colorRed2;
  },
  colorRed20: function colorRed20() {
    return _colorRed3;
  },
  colorRed30: function colorRed30() {
    return _colorRed4;
  },
  colorRed40: function colorRed40() {
    return _colorRed5;
  },
  colorRed50: function colorRed50() {
    return _colorRed6;
  },
  colorRed60: function colorRed60() {
    return _colorRed7;
  },
  colorRed70: function colorRed70() {
    return _colorRed8;
  },
  colorRed80: function colorRed80() {
    return _colorRed9;
  },
  colorRed90: function colorRed90() {
    return _colorRed10;
  },
  colorTurquoise05: function colorTurquoise05() {
    return _colorTurquoise;
  },
  colorTurquoise10: function colorTurquoise10() {
    return _colorTurquoise2;
  },
  colorTurquoise20: function colorTurquoise20() {
    return _colorTurquoise3;
  },
  colorTurquoise30: function colorTurquoise30() {
    return _colorTurquoise4;
  },
  colorTurquoise40: function colorTurquoise40() {
    return _colorTurquoise5;
  },
  colorTurquoise50: function colorTurquoise50() {
    return _colorTurquoise6;
  },
  colorTurquoise60: function colorTurquoise60() {
    return _colorTurquoise7;
  },
  colorTurquoise70: function colorTurquoise70() {
    return _colorTurquoise8;
  },
  colorTurquoise80: function colorTurquoise80() {
    return _colorTurquoise9;
  },
  colorTurquoise90: function colorTurquoise90() {
    return _colorTurquoise10;
  },
  colorYellow05: function colorYellow05() {
    return _colorYellow;
  },
  colorYellow10: function colorYellow10() {
    return _colorYellow2;
  },
  colorYellow20: function colorYellow20() {
    return _colorYellow3;
  },
  colorYellow30: function colorYellow30() {
    return _colorYellow4;
  },
  colorYellow40: function colorYellow40() {
    return _colorYellow5;
  },
  colorYellow50: function colorYellow50() {
    return _colorYellow6;
  },
  colorYellow60: function colorYellow60() {
    return _colorYellow7;
  },
  colorYellow70: function colorYellow70() {
    return _colorYellow8;
  },
  colorYellow80: function colorYellow80() {
    return _colorYellow9;
  },
  colorYellow90: function colorYellow90() {
    return _colorYellow10;
  }
});
var _colorGrey12 = "#161616";
var _colorGrey11 = "#242424";
var _colorGrey10 = "#333333";
var _colorGrey9 = "#4d4d4d";
var _colorGrey60WithOpacity = "#3d3d3d";
var _colorGrey8 = "#6b6b6b";
var _colorGrey7 = "#878787";
var _colorGrey6 = "#a3a3a3";
var _colorGrey5 = "#c2c2c2";
var _colorGrey4 = "#dbdbdb";
var _colorGrey3 = "#f4f4f4";
var _colorGrey2 = "#fcfcfc";
var _colorGrey = "#ffffff";
var _colorBlue10 = "#0a39b7";
var _colorBlue9 = "#124ac2";
var _colorBlue8 = "#1654c8";
var _colorBlue7 = "#1c5ece";
var _colorBlue6 = "#2067d3";
var _colorBlue5 = "#417fda";
var _colorBlue4 = "#6295e0";
var _colorBlue3 = "#8fb3e9";
var _colorBlue2 = "#bbd1f2";
var _colorBlue = "#eef4fc";
var _colorTurquoise10 = "#008f77";
var _colorTurquoise9 = "#029379";
var _colorTurquoise8 = "#019c83";
var _colorTurquoise7 = "#02a68e";
var _colorTurquoise6 = "#00ad96";
var _colorTurquoise5 = "#26b9a6";
var _colorTurquoise4 = "#4cc6b6";
var _colorTurquoise3 = "#80d6cb";
var _colorTurquoise2 = "#b4e6e0";
var _colorTurquoise = "#e1f5f2";
var _colorYellow10 = "#ec9800";
var _colorYellow9 = "#efa600";
var _colorYellow8 = "#f1ae00";
var _colorYellow7 = "#f3b701";
var _colorYellow6 = "#f3bd02";
var _colorYellow5 = "#f5c825";
var _colorYellow4 = "#f7d14d";
var _colorYellow3 = "#fade80";
var _colorYellow2 = "#fdebb2";
var _colorYellow = "#fef7e0";
var _colorGreen10 = "#64b72c";
var _colorGreen9 = "#76c23d";
var _colorGreen8 = "#7fc847";
var _colorGreen7 = "#8bce4f";
var _colorGreen6 = "#93d357";
var _colorGreen5 = "#a3da70";
var _colorGreen4 = "#b3e088";
var _colorGreen3 = "#c9e9ab";
var _colorGreen2 = "#dff2cd";
var _colorGreen = "#f2faeb";
var _colorRed10 = "#c82a32";
var _colorRed9 = "#d1323a";
var _colorRed8 = "#d73d45";
var _colorRed7 = "#e1444b";
var _colorRed6 = "#e44b52";
var _colorRed5 = "#e8656c";
var _colorRed4 = "#ec8086";
var _colorRed3 = "#f2a5a9";
var _colorRed2 = "#f7c9cb";
var _colorRed = "#fce9ea";
var _colorPurple2 = "#673ab7";
var _colorPurple = "#b39ddb";
export { _colorGrey12 as colorGrey90, _colorGrey11 as colorGrey80, _colorGrey10 as colorGrey70, _colorGrey9 as colorGrey60, _colorGrey60WithOpacity as colorGrey60WithOpacity, _colorGrey8 as colorGrey50, _colorGrey7 as colorGrey40, _colorGrey6 as colorGrey30, _colorGrey5 as colorGrey20, _colorGrey4 as colorGrey10, _colorGrey3 as colorGrey05, _colorGrey2 as colorGrey01, _colorGrey as colorGrey00, _colorBlue10 as colorBlue90, _colorBlue9 as colorBlue80, _colorBlue8 as colorBlue70, _colorBlue7 as colorBlue60, _colorBlue6 as colorBlue50, _colorBlue5 as colorBlue40, _colorBlue4 as colorBlue30, _colorBlue3 as colorBlue20, _colorBlue2 as colorBlue10, _colorBlue as colorBlue05, _colorTurquoise10 as colorTurquoise90, _colorTurquoise9 as colorTurquoise80, _colorTurquoise8 as colorTurquoise70, _colorTurquoise7 as colorTurquoise60, _colorTurquoise6 as colorTurquoise50, _colorTurquoise5 as colorTurquoise40, _colorTurquoise4 as colorTurquoise30, _colorTurquoise3 as colorTurquoise20, _colorTurquoise2 as colorTurquoise10, _colorTurquoise as colorTurquoise05, _colorYellow10 as colorYellow90, _colorYellow9 as colorYellow80, _colorYellow8 as colorYellow70, _colorYellow7 as colorYellow60, _colorYellow6 as colorYellow50, _colorYellow5 as colorYellow40, _colorYellow4 as colorYellow30, _colorYellow3 as colorYellow20, _colorYellow2 as colorYellow10, _colorYellow as colorYellow05, _colorGreen10 as colorGreen90, _colorGreen9 as colorGreen80, _colorGreen8 as colorGreen70, _colorGreen7 as colorGreen60, _colorGreen6 as colorGreen50, _colorGreen5 as colorGreen40, _colorGreen4 as colorGreen30, _colorGreen3 as colorGreen20, _colorGreen2 as colorGreen10, _colorGreen as colorGreen05, _colorRed10 as colorRed90, _colorRed9 as colorRed80, _colorRed8 as colorRed70, _colorRed7 as colorRed60, _colorRed6 as colorRed50, _colorRed5 as colorRed40, _colorRed4 as colorRed30, _colorRed3 as colorRed20, _colorRed2 as colorRed10, _colorRed as colorRed05, _colorPurple2 as colorPurple50, _colorPurple as colorPurple20, color_exports };